import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import Icd from './pages/icd/icdList';
import IcdForm from './pages/icd/IcdForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const icdPageRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/icd',
    component: Icd,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.ICD.SEARCH_ICD || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const icdFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: 'icd/form',
    component: IcdForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.ICD.SAVE_ICD || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const icdRoutes = [
    //salesPersonRoute,
    icdPageRoute,
    icdFormRoute
];